module.exports = __webpack_public_path__ + "img/resultfail.f4d84328.svg";